import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GetAppDialogComponent} from '@shared/modules/shared-dialogs/dialogs/get-app-dialog/get-app-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import { SharedBannersModule } from '../shared-banners/shared-banners.module';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    SharedBannersModule,
  ],
  declarations: [
    GetAppDialogComponent,
  ],
  exports: [
    GetAppDialogComponent,
  ]
})
export class SharedDialogModule { }
